import { render, staticRenderFns } from "./purseUseDetail.vue?vue&type=template&id=d9f81c9e&scoped=true"
import script from "./purseUseDetail.vue?vue&type=script&lang=js"
export * from "./purseUseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f81c9e",
  null
  
)

export default component.exports